// Componente de protección de rutas basado en autenticación y roles.
// Redirige al login si el usuario no está autenticado, o a "Unauthorized" si no tiene el rol requerido.

// frontend/src/components/auth/PrivateRoute.js
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Componente para proteger rutas basado en autenticación y roles
const PrivateRoute = ({ children, requiredRoles }) => {
  const { user, loading, userRole } = useAuth();
  const location = useLocation();

  // Mostrar loading mientras se verifica la autenticación
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-custom-brand"></div>
      </div>
    );
  }

  // Si no hay usuario autenticado, redirigir al login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar si el usuario tiene al menos uno de los roles requeridos
  if (
    requiredRoles &&
    !requiredRoles.includes(userRole) &&
    userRole !== 'super_admin'
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Si todo está bien, mostrar el contenido protegido
  return children;
};

export default PrivateRoute;